<template>
  <v-row>
    <v-card max-width="100%" width="100%">
      <v-toolbar color="primary" dark dense>
        <v-tooltip bottom color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="white"
              dark
              v-bind="attrs"
              v-on="on"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <span style="white-space: break-spaces;">{{$t('dd.bufferWeekExplanation')}}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('stats.buffers')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "line" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text >
        <v-row wrap style="max-height: 400px">
          <canvas id="chartKPI" width="800"  height="400"></canvas>
        </v-row>
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
import Chart from 'chart.js';
export default {
  name: "Buffers",
  data() {
    return {
      type: "bar",
      chart: null,
      options: {
        hover: {
          mode: 'index',
          intersect: false
        },
        legend: {
          position: "bottom"
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            itemSort: this.labelsSort,
            callbacks: {
              label: this.labelsFormated
            }
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            display: true,
            ticks: {
                beginAtZero: true
            }
          }]
        }
      }
    };
  },
  mounted() {
    setTimeout(() => this.render(), 0)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    render() {
      let data = {
        labels: [],
        datasets : []
      }
      data.labels = this.categories()
      data.datasets  = this.series(this.$store.getters['company/data'])
      
      if (!this.chart) {
        this.chart = new Chart(document.querySelector("#chartKPI"), {
          type: this.type,
          options: this.options,
          data: data
        })
      }
    },
    categories() {
      
      let categories = [];
      for (let index = 1; index <= this.$store.getters['company/week']; index++) {
        categories.push(this.$t("general.smallWeek") + (index));
        categories.push(this.$t("general.smallWeek") + (index));
        categories.push(this.$t("general.smallWeek") + (index));
      }
      return categories;
    },
    series(company) {
      let series = []
      
      series.push({
        label: this.$t("stats.flowEquation"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: "line",
        lineTension: 0,
        fill: false,
        backgroundColor: '#0000ff',
        borderColor: '#0000ff',
        data: company.dd.buffer.flowEquation
      });
      series.push({
        label: this.$t("stats.stock"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: "line",
        lineTension: 0,
        fill: false,
        backgroundColor: '#000000',
        borderColor: '#000000',
        data: company.dd.buffer.stock
      });
      series.push({
        label: this.$t("stats.red"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#ff0000',
        stack: 'buffer',
        data: company.dd.buffer.red
      });
      series.push({
        label: this.$t("stats.yellow"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#ffff00',
        stack: 'buffer',
        data: this.yellowData(company)
      });
      series.push({
        label: this.$t("stats.green"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#008000',
        stack: 'buffer',
        data: this.greenData(company)
      });
      return series;
    },
    async changeType () {
      await this.chart.destroy()
      this.chart = null

      if (this.type == 'line') {
        this.type = 'bar'
      } else {
        this.type = 'line'
      }
      this.render()
    },
    yellowData(company) {
      if (this.type == 'bar') {
        return company.dd.buffer.yellow
        } else {
        return company.dd.buffer.yellow.map((val, index) => val + company.dd.buffer.red[index])
      }
    },
    greenData(company) {
      if (this.type == 'bar') {
        return company.dd.buffer.green
        } else {
        return company.dd.buffer.green.map((val, index) => val + company.dd.buffer.yellow[index] + company.dd.buffer.red[index])
      }
    },
    labelsFormated (tooltipItem, data) {
      let label = data.datasets[tooltipItem.datasetIndex].label || '';
      if (label) {
          label += ': ';
      }
      if (tooltipItem.datasetIndex == 3 && this.type == 'bar') {
        label += tooltipItem.yLabel + data.datasets[2].data[tooltipItem.index];
      } else if (tooltipItem.datasetIndex == 4 && this.type == 'bar') {
        label += tooltipItem.yLabel + data.datasets[2].data[tooltipItem.index] + data.datasets[3].data[tooltipItem.index];
      } else {
        label += tooltipItem.yLabel
      }
      return label;
    },
    labelsSort (a, b, data) {
      let aNewValue = a.yLabel
      let bNewValue = b.yLabel
      if (a.datasetIndex == 3 && this.type == 'bar') {
        aNewValue += data.datasets[2].data[a.index];
      } else if (a.datasetIndex == 4 && this.type == 'bar') {
        aNewValue += data.datasets[2].data[a.index] + data.datasets[3].data[a.index];
      }
      if (b.datasetIndex == 3 && this.type == 'bar') {
        bNewValue += data.datasets[2].data[b.index];
      } else if (b.datasetIndex == 4 && this.type == 'bar') {
        bNewValue += data.datasets[2].data[b.index] + data.datasets[3].data[b.index];
      }
      return bNewValue - aNewValue;
    }
  },
  computed: {
    bufferCompanies() {
      return this.$store.getters["game/assignableCompanies"].filter((company) => company.ddOn)
    },
    week() {
      let max = 0;
      this.bufferCompanies.forEach(company => {
        if (company.dd.buffer.flowEquation.length > max) {
          max = company.dd.buffer.flowEquation.length;
        }
      });
      return max;
    },
    max() {
      let max = 0
      this.bufferCompanies.forEach(company => {
        company.value.stock.forEach(stock => {
          if (stock > max) {
            max = stock
          }
        });
      });
      return max;
    },
    colSize() {
      return this.bufferCompanies.length > 1 ? '12' : '12';
    }
  }
};
</script>